import React from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePickerContainer } from './styles';
import { DateIcon } from 'assets/icons';

const DatePicker = ({
  disabled,
  error,
  minDate,
  dateValue,
  dateOnChange,
  timelineState,
  setDate,
  additionalstyle,
  variant,
  placeholder
}) => {

  const { state, setState } = timelineState ? timelineState : {};

  const onClickChange = (newValue) => {
    // change Material UI calendar date
    setDate(moment(newValue).tz(TIME_ZONE));

    //change timeline state to jump to selected date
    setState((state) => {
      return {
        ...state,
        visibleTimeStart: moment(newValue)
        .tz(TIME_ZONE)
        .startOf('week')
        .valueOf(),
        visibleTimeEnd: moment(newValue)
        .tz(TIME_ZONE)
        .startOf('week')
        .add(10, 'day')
        .valueOf(),
        today: moment(newValue).tz(TIME_ZONE).startOf('day').valueOf(),
        endToday: moment(newValue).tz(TIME_ZONE).endOf('day').valueOf(),
      };
    });
  };

  return (
    <DatePickerContainer additionalstyle={additionalstyle} disabled={disabled}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DesktopDatePicker
          slots={{
            openPickerIcon: DateIcon
          }}
          disabled={disabled}
          minDate={minDate}
          fullWidth
          label=" "
          inputFormat="MM/dd/yyyy"
          error={error}
          value={dateValue}
          onChange={dateOnChange ? dateOnChange : onClickChange}
          renderInput={(props) => 
            <TextField
              {...props}
              variant={variant}
              autoComplete="off"
              InputProps={{
                ...props.InputProps,
                notched: false,
                id: "datePickerInput",
              }}
            />            
          }
        />
      </LocalizationProvider>
    </DatePickerContainer>
  );
};

export default DatePicker;